const initialState = {
  uiState: "plans",
};

const pricingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "pricing/pricingUIStateChange":
      return {
        ...state,
        uiState: action.state,
      };

    default:
      return state;
  }
};
export default pricingReducer;
